import { HtmlTypography } from 'src/components/HtmlTypography';

interface FaqHtmlContentProps {
  html: string | null | undefined;
}

export function FaqHtmlContent({ html }: FaqHtmlContentProps) {
  if (!html) return null;

  return (
    <HtmlTypography
      sx={{
        lineHeight: 1.55,
        overflowWrap: 'anywhere',
        '& a': {
          color: 'primary.text',
        },
        '& img': {
          display: 'block',
          height: 'auto',
          maxWidth: '100%',
          width: '100%',
        },
        '& iframe': {
          border: 0,
          maxWidth: '100%',
          minHeight: 200,
          width: '100%',
        },
        '& p': {
          my: 1.5,
        },
        '& ul, & ol': {
          my: 1.5,
          pl: 3,
        },
        '& .video': {
          my: 2,
          width: '100%',
        },
        '& .video iframe': {
          aspectRatio: '16 / 9',
          display: 'block',
          width: '100%',
        },
      }}
    >
      {html}
    </HtmlTypography>
  );
}
